import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Globe, Facebook, Instagram } from "lucide-react";
import Logo from "./Logo";
import { useI18n } from "../i18n/I18nContext";
import { useSite } from "../context/SiteContext";

export default function Footer() {
    const { t } = useI18n();
    const { site } = useSite();
    const contact = site?.contact || {};
    const socials = site?.socials || {};
    const services = site?.services || [];
    const { lang } = useI18n();
    return (
        <footer className="bg-brand-navy text-white" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div>
                    <div className="bg-white/5 inline-block px-3 py-2">
                        <Logo light />
                    </div>
                    <p className="mt-5 text-sm text-white/70 max-w-xs leading-relaxed">{t("footer.tagline")}</p>
                </div>
                <div>
                    <h4 className="text-[0.72rem] tracking-[0.22em] uppercase font-semibold text-brand-gold mb-5">
                        {t("footer.quick_links")}
                    </h4>
                    <ul className="space-y-2 text-sm text-white/80">
                        <li><Link to="/" className="hover:text-brand-gold transition">{t("nav.home")}</Link></li>
                        <li><Link to="/services" className="hover:text-brand-gold transition">{t("nav.services")}</Link></li>
                        <li><Link to="/biens" className="hover:text-brand-gold transition">{t("nav.properties")}</Link></li>
                        <li><Link to="/a-propos" className="hover:text-brand-gold transition">{t("nav.about")}</Link></li>
                        <li><Link to="/contact" className="hover:text-brand-gold transition">{t("nav.contact")}</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="text-[0.72rem] tracking-[0.22em] uppercase font-semibold text-brand-gold mb-5">
                        {t("footer.our_services")}
                    </h4>
                    <ul className="space-y-2 text-sm text-white/80">
                        {services.slice(0, 5).map((s) => (
                            <li key={s.key || s.title_fr}>{lang === "en" ? s.title_en || s.title_fr : s.title_fr}</li>
                        ))}
                    </ul>
                </div>
                <div>
                    <h4 className="text-[0.72rem] tracking-[0.22em] uppercase font-semibold text-brand-gold mb-5">
                        {t("footer.contact")}
                    </h4>
                    <ul className="space-y-2 text-sm text-white/80">
                        {(contact.phones || []).map((p) => (
                            <li key={p.display} className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-brand-gold" />{p.display}</li>
                        ))}
                        {(contact.emails || []).slice(0, 1).map((e) => (
                            <li key={e} className="flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-brand-gold" />{e}</li>
                        ))}
                        {contact.website ? (
                            <li className="flex items-center gap-2"><Globe className="w-3.5 h-3.5 text-brand-gold" />{contact.website}</li>
                        ) : null}
                        {contact.address ? (
                            <li className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-brand-gold" />{contact.address}</li>
                        ) : null}
                    </ul>
                    <div className="mt-5 flex items-center gap-3">
                        {socials.facebook ? (
                            <a href={socials.facebook} target="_blank" rel="noreferrer" className="w-9 h-9 inline-flex items-center justify-center bg-white/10 hover:bg-brand-gold transition-colors" aria-label="Facebook">
                                <Facebook className="w-4 h-4" />
                            </a>
                        ) : null}
                        {socials.instagram ? (
                            <a href={socials.instagram} target="_blank" rel="noreferrer" className="w-9 h-9 inline-flex items-center justify-center bg-white/10 hover:bg-brand-gold transition-colors" aria-label="Instagram">
                                <Instagram className="w-4 h-4" />
                            </a>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-center text-xs text-white/60">
                    © {new Date().getFullYear()} GAB'S SERVICES SARL MALI — {t("footer.rights")}.
                </div>
            </div>
        </footer>
    );
}
